document.addEventListener('Searchanise.Loaded', function () {
	(function ($) {
		$(document).on('Searchanise.AddToCartSuccess', function (response) {
			setTimeout(function () {
				//console.log('response', response);
				$('.snize-overhidden .size-button-view-cart')
					.removeClass('size-button-view-cart')
					.text(Searchanise.GetWidgets().options.LabelResultsAddToCart);
			}, 0);
		});
		function snizeAppendUnit(productEl) {
			var productData = productEl.data('snize_item_data');
			// console.log('productData', productData);
			var productHandle = Searchanise.ExtractProductHandle(productData.link);
			let avgReviews = parseFloat(productData.reviews_average_score).toFixed(1);
			let totalReviews = productData.total_reviews;
			// console.log(avgReviews + " - " + totalReviews);
			$.get('/products/' + productHandle + '.xml').done(function (product_data) {
				if ($(product_data).find('variants').length) {
					if (productEl.find('.snize-size').length) {
						var selected = productEl.find('.snize-size.snize-size-active').text();
						var variantEl = $(product_data)
							.find('variants')
							.find('variant')
							.filter(function () {
								return $(this).find('option1').text() == selected;
							});
					} else {
						var variantEl = $(product_data).find('variants').find('variant').first();
					}
					if (variantEl.find('unit-price-measurement').length && !$('.unit-price-measurement-wrapper', productEl).length) {
						var unitPriceFormatted = Searchanise.GetWidgets().formatPrice(variantEl.find('unit-price').text());
						$('.snize-price-list', productEl).append(
							'<br>' +
							'<span class="unit-price-measurement-wrapper">' +
								'<span class="money">' +
								unitPriceFormatted +
								'</span> / ' +
								'annos' +
								'</span>'
						);
					}
					if (productEl.find('.snize-reviews').length && !$('.total-avg-reviews', productEl).length) {
					//if (!$('.avg-reviews', productEl) == false && !$('.total-avg-reviews', productEl) == false ) {
						// console.log("Found reviews");
						$('.snize-reviews', productEl).prepend(
								'<span class="avg-reviews">' +
								avgReviews +
								'</span>'
						);
						$('.snize-reviews', productEl).append(
							'<span class="total-avg-reviews">(' +
							totalReviews +
							')</span>'
						);
					}
				}
			});
		}
		$(document).on('Searchanise.ResultsUpdated', function () {
			$('.snize-search-results .snize-product').each(function () {
				snizeAppendUnit($(this));
			});
		});
		$(document).on('Searchanise.AutocompleteUpdated', function () {
			$('.snize-ac-results .snize-product').each(function () {
				snizeAppendUnit($(this));
			});
		});
	})(window.Searchanise.$);
});

document.addEventListener('ajaxProduct:added', function(evt) {
   var title = evt.detail.variant.product_title;
  var id = evt.detail.variant.product_id;
  var img = evt.detail.variant.image;
  var url = evt.detail.variant.url;
  var brand = evt.detail.variant.vendor;
  var price = theme.Currency.formatMoney(
							evt.detail.variant.price,
							theme.settings.moneyFormat
						);
  var compare = theme.Currency.formatMoney(
							evt.detail.variant.original_price,
							theme.settings.moneyFormat
						);
var item = {
    Name: title,
    ProductID: id,
    ImageURL: img,
    URL: url,
    Brand: brand,
    Price: price,
    CompareAtPrice: compare
  };
});
